export interface IPesquisaConsultores {
    id: number
    nome: string
}

export const defValueConsultor: IPesquisaConsultores = {
    id: 0,
    nome: ""
}

